import { Outlet } from "react-router";
import { V2Header } from "@/v2/layout/v2Header";
import { V2Sidebar } from "@/v2/layout/v2Sidebar";

export function V2Layout(): React.JSX.Element {
  return (
    <div className="flex h-screen flex-col overflow-hidden bg-background">
      <V2Header />
      <div className="flex min-h-0 flex-1">
        <V2Sidebar />
        <main className="flex-1 overflow-y-auto overflow-x-hidden">
          <div className="mx-auto max-w-7xl space-y-6 px-8 py-8">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}
